var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H10",
    stroke: "#EAF5FE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C12.1046 2 13 2.89543 13 4V12C13 13.1046 12.1046 14 11 14H5C3.89543 14 3 13.1046 3 12V4C3 2.89543 3.89543 2 5 2H11ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12H7.5C7.77614 12 8 11.7761 8 11.5C8 11.2239 7.77614 11 7.5 11H5.5ZM5.42871 9C5.19202 9 5 9.22386 5 9.5C5 9.77614 5.19202 10 5.42871 10H10.5713C10.808 10 11 9.77614 11 9.5C11 9.22386 10.808 9 10.5713 9H5.42871ZM5.42871 7C5.19202 7 5 7.22386 5 7.5C5 7.77614 5.19202 8 5.42871 8H10.5713C10.808 8 11 7.77614 11 7.5C11 7.22386 10.808 7 10.5713 7H5.42871ZM5.66699 5C5.57494 5 5.5 5.07494 5.5 5.16699V5.5C5.5 5.77614 5.72386 6 6 6C6.27614 6 6.5 5.77614 6.5 5.5V5.16699C6.5 5.07494 6.42506 5 6.33301 5H5.66699ZM7.90039 4C7.67948 4 7.5 4.17948 7.5 4.40039V5.5C7.5 5.77614 7.72386 6 8 6C8.27614 6 8.5 5.77614 8.5 5.5V4.40039C8.5 4.17948 8.32052 4 8.09961 4H7.90039ZM9.90039 3C9.67948 3 9.5 3.17948 9.5 3.40039V5.5C9.5 5.77614 9.72386 6 10 6C10.2761 6 10.5 5.77614 10.5 5.5V3.40039C10.5 3.17948 10.3205 3 10.0996 3H9.90039Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/Reporting.e3b9d627f9c94aa784b72824e5fdfc85.svg";
export { ForwardRef as ReactComponent };